const BASE_PATH = '/experiences'

// TODO: Fix paths
export const experienceEvents = [
    {
        date: 'Sep 2013',
        key: 'firstTime',
        titleCopyPath: ['events', 'firstTime', 'title'],
        src: `${BASE_PATH}/first-time.png`,
        descriptionCopyPath: [],
        bulletsDescriptionCopyPath: [],
        bullets: [
            {
                key: 'firstTime',
                bulletPath: [],
            },
        ],
    },
    {
        date: 'Jan - Jun 2017',
        key: 'ta',
        titleCopyPath: ['events', 'ta', 'title'],
        src: `${BASE_PATH}/mount-doug-logo.png`,
        descriptionCopyPath: [],
        bulletsDescriptionCopyPath: [],
        bullets: [
            {
                key: 'ta',
                bulletPath: [],
            },
        ],
    },
    {
        date: 'Sep 2017',
        key: 'universityStart',
        titleCopyPath: ['events', 'universityStart', 'title'],
        src: `${BASE_PATH}/uvic-logo.png`,
        descriptionCopyPath: [],
        bulletsDescriptionCopyPath: [],
        bullets: [
            {
                key: 'universityStart',
                bulletPath: [],
            },
        ],
    },
    {
        date: 'May - Aug 2018',
        key: 'universityEss',
        titleCopyPath: ['events', 'universityEss', 'title'],
        src: `${BASE_PATH}/uvic-ess-logo.png`,
        descriptionCopyPath: [],
        bulletsDescriptionCopyPath: [],
        bullets: [
            {
                key: 'universityEss',
                bulletPath: [],
            },
        ],
    },
    {
        date: 'Jan 2019 - April 2020',
        key: 'freshWorks',
        titleCopyPath: ['events', 'freshWorks', 'title'],
        src: `${BASE_PATH}/freshworks-logo.png`,
        descriptionCopyPath: [],
        bulletsDescriptionCopyPath: [],
        bullets: [
            {
                key: 'freshWorks',
                bulletPath: [],
            },
        ],
    },
    {
        date: 'April 2020 - Dec 2021',
        key: 'fispanCoop',
        titleCopyPath: ['events', 'fispanCoop', 'title'],
        src: `${BASE_PATH}/fispan-logo.webp`,
        descriptionCopyPath: [],
        bulletsDescriptionCopyPath: [],
        bullets: [
            {
                key: 'fispanCoop',
                bulletPath: [],
            },
        ],
    },
    {
        date: 'Dec 2021',
        key: 'universityEnd',
        titleCopyPath: ['events', 'universityEnd', 'title'],
        src: `${BASE_PATH}/uvic-grad-logo.png`,
        descriptionCopyPath: [],
        bulletsDescriptionCopyPath: [],
        bullets: [
            {
                key: 'universityEnd',
                bulletPath: [],
            },
        ],
    },
    {
        date: 'Jan 2022 - Present',
        key: 'fispanFullTime',
        titleCopyPath: ['events', 'fispanFullTime', 'title'],
        src: `${BASE_PATH}/fispan-logo.webp`,
        descriptionCopyPath: [],
        bulletsDescriptionCopyPath: [],
        bullets: [
            {
                key: 'fispanFullTime',
                bulletPath: [],
            },
        ],
    },
]
